<template>
    <div>

        <vue-headful title="Equipment Email Alert :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link to="/admin/equipment-types">
                        Equipment Types
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/admin/equipment-types-edit/${alert.equipment_type_id}#alerts`">
                        Edit Type
                    </router-link>
                </li>
                <li class="breadcrumb-item active">Delete Alert</li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-4 col-12 mb-lg-0 mb-3">
                    <div class="card">
                        <div class="card-header">
                            Delete Alert
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>WARNING:</strong> You are about to delete this equipment email alert, all its conditions, and all its recipients. This cannot be undone. Do you wish to continue?
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteAlert()" :disabled="saving">
                                <template v-if="!saving">Yes, Delete this Email Alert Rule</template>
                                <template v-else>Deleting...</template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                saving: false,
                errors: {},
                alert: {},
            }
        },

        methods: {
            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('admin/equipment-alerts/view/' + this.id)
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;

                        //Emails
                        this.emails = res.data.emails;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteAlert(){
                //Doing it
                this.saving = true;

                //Send it
                this.$http.post('admin/equipment-alerts/delete/' + this.id)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Email Alert Deleted');

                        //Push
                        this.$router.push(`/admin/equipment-types-edit/${this.alert.equipment_type_id}#alerts`);
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
